import { createContext } from 'react';

import type { EventNavigationContextValue } from './navigation.type';

export const EventNavigationContext = createContext<EventNavigationContextValue>({
  eventNavigationItems: [],
  setEventNavigation: () => {},
});
